import { Mail, Phone, ArrowLeftRight } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";

export default function TopBar() {
  const { currency, toggle, rate } = useCurrency();

  return (
    <div
      data-testid="top-bar"
      className="hidden md:block bg-apex-navyDeep/80 backdrop-blur-md border-b border-white/[0.06]"
    >
      <div className="container-apex flex items-center justify-between h-9 text-[12px] text-white/70">
        <div className="flex items-center gap-5 min-w-0">
          <a
            href="tel:+917719779448"
            data-testid="topbar-phone"
            className="flex items-center gap-1.5 hover:text-white transition-colors whitespace-nowrap"
          >
            <Phone className="w-3.5 h-3.5 text-apex-orange" strokeWidth={2} />
            +91 77197 79448
          </a>
          <span className="text-white/15">|</span>
          <a
            href="mailto:info@apexinnovationsolutions.com"
            data-testid="topbar-email-business"
            className="flex items-center gap-1.5 hover:text-white transition-colors whitespace-nowrap"
          >
            <Mail className="w-3.5 h-3.5 text-apex-cyan" strokeWidth={2} />
            info@apexinnovationsolutions.com
          </a>
        </div>

        <div className="flex items-center gap-3">
          <span className="hidden xl:inline text-white/45">
            1 USD ≈ ₹{rate}
          </span>
          <button
            type="button"
            onClick={toggle}
            data-testid="currency-toggle"
            aria-label="Toggle currency"
            className="group inline-flex items-center gap-1 rounded-full border border-white/15 bg-white/[0.04] p-0.5 hover:border-white/30 transition-colors"
          >
            <span
              className={`px-2 py-0.5 rounded-full text-[11px] font-semibold transition-all ${
                currency === "USD"
                  ? "bg-apex-orange text-white shadow-[0_0_12px_rgba(255,107,53,0.5)]"
                  : "text-white/60"
              }`}
              data-testid="currency-usd"
            >
              USD
            </span>
            <ArrowLeftRight className="w-3 h-3 text-white/40 group-hover:text-white transition-colors" strokeWidth={2} />
            <span
              className={`px-2 py-0.5 rounded-full text-[11px] font-semibold transition-all ${
                currency === "INR"
                  ? "bg-apex-cyan text-apex-navy shadow-[0_0_12px_rgba(35,211,255,0.5)]"
                  : "text-white/60"
              }`}
              data-testid="currency-inr"
            >
              INR
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
